<company-banner *ngIf="company.bannerUrl" [company]="company" class="company-banner"></company-banner>

<div class="company-header" [class.company-header--no-banner]="!company.bannerUrl">
  <company-logo class="company-header__logo" size="large" [company]="company"></company-logo>

  <div class="company-header__info company-info">
    <div class="company-info__main">
      <h1 class="company-info__name">
        {{ company.name }}
      </h1>

      <span class="company-info__tagline">
        {{ company.tagLine }}
      </span>

      <div class="company-info__icons">
        <div *ngIf="company.location?.short" class="company-info__icon">
          <app-svg-icon icon="exp-location" width=".563em" height=".767em"></app-svg-icon>
          &nbsp;
          {{ company.location.short }}
        </div>

        <div *ngIf="company.employees && company.employees > 0" class="company-info__icon">
          <app-svg-icon icon="people" width="1em" height=".938em"></app-svg-icon>
          &nbsp;{{ company.employees | number }}
        </div>

        <div *ngIf="company.industry" class="company-info__icon">
          <app-svg-icon icon="business" width=".625em" height=".813em"></app-svg-icon>
          &nbsp;
          <app-i18n-field [model]="company.industry"></app-i18n-field>
        </div>

        <div *ngIf="company.websiteUrl" class="company-info__icon">
          <app-svg-icon icon="web" width=".938em"></app-svg-icon>
          &nbsp;
          <a class="company-info__link" [href]="company.websiteUrl" target="_blank" rel="noopener">{{
            company.websiteUrl
          }}</a>
        </div>
      </div>
    </div>

    <div class="company-info__follow">
      <div class="company-info__follow--actions">
        <button *ngIf="!company.isCurrentUserFollowingIt" class="btn" type="button" (click)="follow(company.id)" i18n>
          S'abonner
        </button>

        <button
          *ngIf="company.isCurrentUserFollowingIt"
          class="btn btn--ghost"
          type="button"
          (click)="unfollow(company.id)"
          i18n
        >
          Se désabonner
        </button>
      </div>

      <div class="company-info__follow--numbers followers">
        <span class="followers__number">{{ company.numberOfFollowers }}</span>
        <span class="followers__text" i18n>abonné{{ company.numberOfFollowers > 1 ? 's' : '' }}</span>
      </div>
    </div>
  </div>
</div>
